import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55224547"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toast-container" }
const _hoisted_2 = { class: "toast__body" }
const _hoisted_3 = { class: "toast__message" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "toast__progress" }

import { useToast } from "@/services/useToast";


export default /*#__PURE__*/_defineComponent({
  __name: 'ToastContainer',
  setup(__props) {

const { toasts, dismiss } = useToast();

const iconFor = (color: string) => {
  const icons: Record<string, string> = {
    success: "mdi-check-circle-outline",
    error: "mdi-alert-circle-outline",
    warning: "mdi-alert-outline",
    info: "mdi-information-outline",
  };
  return icons[color] ?? "mdi-information-outline";
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, { name: "toast" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toasts), (toast) => {
            return (_openBlock(), _createElementBlock("div", {
              key: toast.id,
              class: _normalizeClass(["toast", `toast--${toast.color}`])
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_icon, {
                  class: "toast__icon",
                  icon: iconFor(toast.color),
                  size: "20"
                }, null, 8, ["icon"]),
                _createElementVNode("span", _hoisted_3, _toDisplayString(toast.message), 1),
                _createElementVNode("button", {
                  class: "toast__close",
                  onClick: ($event: any) => (_unref(dismiss)(toast.id))
                }, [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-close",
                    size: "16"
                  })
                ], 8, _hoisted_4)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "toast__progress-bar",
                  style: _normalizeStyle({ animationDuration: `${toast.timeout}ms` })
                }, null, 4)
              ])
            ], 2))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})